import tw from "twin.macro";

export const PrimaryLink = tw.a`cursor-pointer font-bold text-red-600 border-b-2 border-transparent hocus:border-gray-800 hocus:text-primary-800 transition duration-300`;
